var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPPerfectionist(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#FEFAF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#F7B27A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9974 62V18.3636H41.361C44.7133 18.3636 47.5258 18.9886 49.7985 20.2386C52.0855 21.4886 53.8113 23.2074 54.9761 25.3949C56.1551 27.5682 56.7446 30.0398 56.7446 32.8097C56.7446 35.608 56.1551 38.0937 54.9761 40.267C53.7971 42.4403 52.0571 44.152 49.7559 45.402C47.4548 46.6378 44.621 47.2557 41.2545 47.2557H30.4093V40.7571H40.1892C42.1494 40.7571 43.7545 40.4162 45.0045 39.7344C46.2545 39.0526 47.1778 38.1151 47.7744 36.9219C48.3852 35.7287 48.6906 34.358 48.6906 32.8097C48.6906 31.2614 48.3852 29.8977 47.7744 28.7188C47.1778 27.5398 46.2474 26.6236 44.9832 25.9702C43.7332 25.3026 42.121 24.9688 40.1465 24.9688H32.9022V62H24.9974Z",
    fill: "#EF6820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPPerfectionist);
export default __webpack_public_path__ + "static/media/p-perfectionist.ef9f84e0e486ab0dccfb208c38a7bb05.svg";
export { ForwardRef as ReactComponent };